import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalVariable } from '../globals';

@Injectable({
  providedIn: 'root'
})
export class EstimateDetailsService {

  constructor(private http: HttpClient) {}

  getServiceDetail(serviceId: string, serviceName: string): Observable<any> {
    const vehicleData = JSON.parse(localStorage.getItem('vehicleData') || 'null');
    const variantKey = vehicleData?.variantKey || localStorage.getItem('variantKey');
    const carSize = vehicleData?.carSize || localStorage.getItem('carSize');
    const garageKey = localStorage.getItem('garageKey') || '';
    return this.http.get(`${GlobalVariable.BASE_API_URL}` + '/api/v1/service/getServiceDetail?garageKey='+garageKey+'&serviceId='+serviceId+'&serviceName='+encodeURIComponent(serviceName)+'&variantKey='+variantKey+'&carSize='+carSize);
  }
      createBooking(payload: any): Observable<any> {
    const url = `${GlobalVariable.BASE_API_URL}` + '/booking/v1/create';
    return this.http.post<any>(url, payload);
  }
}
